import { head } from 'ramda'
import { useMutation, gql } from '@apollo/client'
import { useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { sessionsClient } from '../../../../utils/apollo/api'
import { useSetTabByName } from '../../../../components/tabs/TabsContext'

const MUTATION = gql`
  mutation ResetPassword($email: String) {
    resetPassword(email: $email)
  }
`

const useRequestPassword = email => {
  const { t } = useTranslation(['session', 'common'])
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, { client: sessionsClient })
  const setTab = useSetTabByName()

  const handleRequest = e => {
    e.preventDefault()

    return request({ variables: { email } }).then(resp => {
      if (!resp.errors) {
        setTab('success')
      } else {
        const errorMessage = head(resp.errors)?.message
        notify.error({
          title: errorMessage,
          ...(!errorMessage?.includes('ativo no sistema') && { message: t('forgotPasswordForm.tryAgain') })
        })
      }
    })
  }

  return [handleRequest, state]
}

export default useRequestPassword
